import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import LogoIL from "assets/images/logo_full.png";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const languageParam = searchParams.get('language');

  useEffect(() => {
    // Map language query param (0=en, 1=fr) to i18n language
    if (languageParam === '1' && i18n.language !== 'fr') {
      i18n.changeLanguage('fr');
    } else if ((languageParam === '0' || languageParam === null) && i18n.language !== 'en') {
      i18n.changeLanguage('en');
    }
  }, [languageParam, i18n]);

  const toggleLanguage = () => {
    const nextLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(nextLang);
    const newParams = new URLSearchParams(location.search);
    newParams.set('language', nextLang === 'fr' ? '1' : '0');
    navigate({ pathname: location.pathname, search: `?${newParams.toString()}` }, { replace: true });
  };

  const supportEmail = "support@innerlogic.com";

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#ffffff',
      color: '#0B1520',
      padding: '40px'
    }}>
      <div style={{ position: 'fixed', top: 15, right: 30, zIndex: 10000 }}>
        <button
          onClick={toggleLanguage}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 14px',
            borderRadius: 10,
            background: '#0B1520',
            color: '#ffffff',
            fontWeight: 700,
            textDecoration: 'none',
            border: '1px solid #0B1520',
            cursor: 'pointer'
          }}
        >
          <Icon name="translate" />
          {t('NotFound.LangToggle')}
        </button>
      </div>
      <div style={{
        maxWidth: 720,
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#ffffff',
        borderRadius: 12,
        border: '1px solid #EEEEEE',
        boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
        padding: '48px 32px'
      }}>
        <img src={LogoIL} alt="Innerlogic" style={{ height: 48, marginBottom: 12 }} />
        <h1 style={{
          fontSize: 56,
          lineHeight: 1.1,
          margin: '8px 0',
          letterSpacing: -1,
          fontWeight: 800
        }}>404</h1>
        <h2 style={{
          fontSize: 24,
          margin: '0 0 12px 0',
          fontWeight: 700,
          color: '#0B1520'
        }}>{t('NotFound.Title')}</h2>
        <p style={{
          fontSize: 16,
          margin: '0 auto 8px auto',
          maxWidth: 560,
          color: '#333'
        }}>
          {t('NotFound.Desc1')}
        </p>
        <p style={{
          fontSize: 16,
          margin: '0 auto 24px auto',
          maxWidth: 560,
          color: '#333'
        }}>
          {t('NotFound.Desc2')} {" "}
          <a href={`mailto:${supportEmail}`} style={{ color: '#0B1520', fontWeight: 700 }}>{supportEmail}</a>.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          <a
            href={`mailto:${supportEmail}?subject=Help with survey link`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '12px 18px',
              borderRadius: 10,
              background: '#ffffff',
              color: '#0B1520',
              fontWeight: 700,
              textDecoration: 'none',
              border: '1px solid #0B1520'
            }}
          >
            <Icon name="mail" />
            {t('NotFound.Button')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

